import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { InfoService } from '@app/core/info/info.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivationData, ActivationStatusStep, ActivationStep, BissSerialResponse } from '../activation.model';
import { FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivationService } from '../services/activation.service';
import { Subject } from 'rxjs';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { BissManager } from '../services/biss-manager';

@Component({
  selector: 'cloud-otp-validation',
  templateUrl: './otp-validation.component.html',
  styleUrls: ['./otp-validation.component.scss']
})
export class OtpValidationComponent implements OnInit {

  @Output() stepCompleteEvent = new EventEmitter();
  smsCodeForm: FormGroup;
  @Input()
  activationData: ActivationData

  disableGenerate = false;

  private unsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public info: InfoService,
    private translateService: TranslateService,
    private formBuilder: FormBuilder,
    private activationService: ActivationService,
    private bissManager: BissManager) {
  }

  ngOnInit() {
    this.initForm();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private initForm() {
    this.smsCodeForm = this.formBuilder.group({
      smsCode: new FormControl('', [Validators.minLength(4), Validators.required])
    })
  }

  generateCode() {
    this.activationService
      .generateOTP(this.activationData.serviceRequestId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(r =>{
        if(r.status === 200){
          this.disableGenerate = true;
          setTimeout(() => {this.enableGenerateOTPButton()}, 15000);
          this.info.success(this.translateService.instant('activation.otp.generateSuccess'))
        }else {
          this.info.error(this.translateService.instant('activation.otp.generateFail'))
        }
    } );
  }

  enableGenerateOTPButton() {
    this.disableGenerate = false;
  }

  confirmCode() {
    const code:string = this.smsCodeForm.value.smsCode;

    this.bissManager
      .checkSmartCard()
      .pipe(switchMap((res) => {
       
        return res.pipe(switchMap((res: BissSerialResponse) => {
          const req = {
            requestId: this.activationData.serviceRequestId,
            code: code,
            cardSerialNumber: res.cardSerialNumber}
          return this.activationService
            .validateOTP(req)
            .pipe(map(r => {
              if (r.status === 200) {
                if (r.otpValid && r.serialMatches) {
                  this.stepComplete();
                } else {
                  if (!r.otpValid) {
                    this.info.error(this.translateService.instant('activation.otp.invalidCode'))
                    return;  
                  }
                  if (!r.serialMatches) {
                    this.info.error(this.translateService.instant('activation.otp.keypairNotFound'))
                    return;  
                  }
                }
              }
            }))
        }))
      })).subscribe()
  }

  stepComplete() {
    if(this.activationData.deliveryStatus === 'REMOTE_DELIVERY'){
      this.activationService.updateStatus(this.activationData.serviceRequestId,ActivationStatusStep.SUCCESSFULLY_CHANGE_PIN_PUK).subscribe((res:any) => {
        if (res.status === 200) {
          this.info.success(this.translateService.instant('activation.otp.success'));
          this.stepCompleteEvent.emit(ActivationStep.PIN);
        } else {
          this.info.error(this.translateService.instant('activation.otp.invalidCode'));
        }
      })
    }else{

      this.info.success(this.translateService.instant('activation.otp.success'))
      this.stepCompleteEvent.emit(ActivationStep.OTP);
    }
  }
}
